import {IPropiedadesForma} from "../../interfaces/IPropiedadesForma";
import {enums} from "../../enums/enums";
import {IDocumento} from "../../interfaces/IDocumento";
import {IConcepto} from "../../interfaces/IConcepto";
import {IConceptoIcono} from "../../interfaces/IConceptoIcono";


export interface IServicioConfiguracion {
    esCotizacionExterno: boolean
    conceptoCategoriaCotizacionId: number
    esOrigenCotizacion: boolean
    esDestinoCotizacion: boolean
    esCotizacionSeccionOrigenDestino: boolean
    esCotizacionSeccionServiciosAdicionales: boolean
    esSolicitudServicioExterno: boolean
    conceptoCategoriaSolicitudServicioId: number
    esOrigenSolicitudServicio: boolean
    esDestinoSolicitudServicio: boolean
    esSolicitudServicioSeccionOrigenDestino: boolean
    esSolicitudServicioSeccionServiciosAdicionales: boolean,
    esDocumentacionGuia?: boolean
    conceptoIcono?: IConceptoIcono
}

export interface IServicioAdicional extends IPropiedadesForma {
    nombre: string
    categoriaId: number
    esOrigen: boolean
    esDestino: boolean
    esSeccionOrigenDestino: boolean
    esSeccionServiciosAdicionales: boolean
    esCantidad: boolean
    seleccionado: boolean
    aplicaOrigen: boolean
    aplicaDestino: boolean
    cantidad?: number | null
    configuracion: IServicioConfiguracion
    documentos?: IDocumento[]
    esRetornoDocumentos?: boolean
    seleccionDirecta?: boolean
    dialogAbierto?: boolean
    abrirDialog?: boolean
    esRequerido?: boolean
    costo?: number | null
    concepto?: IConcepto
    cantidadOrigen?: number | null
    cantidadDestino?: number | null
    tipoCostoID: number
    convenioId: number
    tieneConvenio?: boolean
    abierto: number
    mostrarCheckOrigen: boolean
    mostrarCheckDestino: boolean
    mostrarCantidadOrigen: boolean
    mostrarCantidadDestino: boolean
    destinoSeleccionado: boolean
    esAbierto: boolean
    etiquetaServicioAdicionalDto: any;
    
}

export class ServicioAdicional {
    constructor(props: IServicioAdicional) {
        Object.assign(this, props);
        this.esFormaValida = true;
        this.dialogAbierto = false;
        this.convenioId = 0;
        this.tieneConvenio = false;
        this.esRequerido = !!props.esRequerido;
    }

    ConfigurarOrigenDestino(esOrigen: boolean, esCotizacion: boolean) {
        const configuracion = this.configuracion;

        if (configuracion) {
            const aplicaEnCotizacion = esCotizacion && configuracion.esCotizacionExterno;
            const aplicaEnSolicitud = !esCotizacion && configuracion.esSolicitudServicioExterno;

            this.esOrigen = esOrigen;
            this.esDestino = !esOrigen;
            this.esRetornoDocumentos = this.id === enums.servicioAdicional.retornoDocumentos;
            this.esAbierto = this.abierto === 1;
            this.categoriaId = esCotizacion ?
                configuracion.conceptoCategoriaCotizacionId : configuracion.conceptoCategoriaSolicitudServicioId;

            this.esSeccionOrigenDestino =
                (aplicaEnCotizacion && configuracion.esCotizacionSeccionOrigenDestino)
                || (aplicaEnSolicitud && configuracion.esSolicitudServicioSeccionOrigenDestino);

            this.esSeccionServiciosAdicionales =
                (aplicaEnCotizacion && configuracion.esCotizacionSeccionServiciosAdicionales)
                || (aplicaEnSolicitud && configuracion.esSolicitudServicioSeccionServiciosAdicionales);

            if (this.seleccionado === undefined) {
                this.seleccionado = false;
            }

            if (this.esSeccionOrigenDestino) {
                this.aplicaOrigen = esOrigen && this.tipoCostoID !== enums.tipoCosto.unicoPorCantidad;
                this.mostrarCantidadOrigen = this.aplicaOrigen && this.tipoCostoID === enums.tipoCosto.cantidad
                this.aplicaDestino = !esOrigen;
                this.mostrarCantidadDestino = !esOrigen
                    && (this.tipoCostoID === enums.tipoCosto.cantidad || this.tipoCostoID === enums.tipoCosto.unicoPorCantidad);
            }
        }
    }

    Configurar(convenioId: number) {
        const tieneConvenio = convenioId > 0;
        const checkDestinoSeleccionado = this.tipoCostoID === enums.tipoCosto.unicoPorCantidad
            || this.tipoCostoID === enums.tipoCosto.cantidad && tieneConvenio;

        if (this.seleccionado === undefined) {
            this.seleccionado = false;
        }

        this.convenioId = convenioId;
        this.abrirDialog = this.esSeccionServiciosAdicionales && this.esRetornoDocumentos;

        this.mostrarCheckOrigen = this.esOrigen

            && this.tipoCostoID !== enums.tipoCosto.unicoPorCantidad
            && (!tieneConvenio || this.tipoCostoID !== enums.tipoCosto.cantidad);
        this.mostrarCantidadOrigen = this.tipoCostoID === enums.tipoCosto.cantidad && !tieneConvenio;
        this.mostrarCheckDestino = this.esDestino;
        this.mostrarCantidadDestino = this.tipoCostoID === enums.tipoCosto.cantidad
            || this.tipoCostoID === enums.tipoCosto.unicoPorCantidad;
        this.destinoSeleccionado = checkDestinoSeleccionado;
    }

    Seleccionar(esDesdeDialog: boolean, quitar: boolean) {
        this.ValidarCampos(esDesdeDialog);

        this.seleccionado = !quitar
            && (
                (esDesdeDialog && this.esFormaValida)
                || (!this.esCantidad && (this.aplicaOrigen || this.aplicaDestino))
                || (this.cantidad != null && this.cantidad > 0)
                || (this.aplicaDestino || this.aplicaOrigen)
            );


        if (!this.seleccionado && (!this.aplicaDestino && !this.aplicaOrigen)) {
            this.LimpiarCampos();
        }
    }

    LimpiarCampos() {
        this.cantidad = null;
        this.cantidadDestino = null;
        this.cantidadOrigen = null;
        this.aplicaOrigen = !this.esDestino;
        this.aplicaDestino = !this.esOrigen;
        this.documentos = [];
    }

    SeleccionarPorClick(): boolean {
        const checksInvalidos = this.mostrarCheckOrigen && this.mostrarCheckDestino
            && !this.aplicaOrigen && !this.aplicaDestino;

        if (checksInvalidos) return false;

        this.seleccionado = true;

        if (this.esSeccionServiciosAdicionales) {
            this.aplicaOrigen = this.mostrarCheckOrigen;
            this.aplicaDestino = this.mostrarCheckDestino;
        }

        return true;
    }

    Deseleccionar(documentosCliente) {
        this.seleccionado = false;
        this.cantidad = null;
        this.cantidadOrigen = null;
        this.cantidadDestino = null;
        this.costo = null;

        if (this.esSeccionServiciosAdicionales) {
            this.aplicaOrigen = false;
            this.aplicaDestino = false;
        }

        if (this.esRetornoDocumentos){
            this.cantidad = documentosCliente.length != null? documentosCliente.length: null;
            this.documentos = documentosCliente;
        }
    }

    CambiarValores() {
        this.cantidadOrigen = this.aplicaOrigen ? this.cantidadOrigen : null;
        this.cantidadDestino = this.aplicaDestino ? this.cantidadDestino : null;

        if (this.esSeccionOrigenDestino) {
            this.seleccionado = !!this.cantidadOrigen || !!this.cantidadDestino;
        } else {
            this.seleccionado = this.aplicaOrigen || this.aplicaDestino;
        }

        this.costo = this.seleccionado ? this.costo : null;
    }

    CantidadInvalida() {
        return this.seleccionado
            && (
                (this.aplicaOrigen && this.mostrarCantidadOrigen && !this.cantidadOrigen)
                || (this.aplicaDestino && this.mostrarCantidadDestino && !this.cantidadDestino)
            )
    }

    CostoInvalido() {
        return this.seleccionado && this.esAbierto && !this.costo
    }

    private ValidarCampos(esDesdeDialog: boolean) {
        if (!esDesdeDialog) return;

        //Si el servicio se encuentra en origen y destino, debe seleccionar por lo menos una opción (aplicaOrigen o aplicaDestino)
        if (this.mostrarCheckOrigen && this.mostrarCheckDestino && !this.aplicaOrigen && !this.aplicaDestino) {
            this.esFormaValida = false;
        }
    }
}

export interface ServicioAdicional extends IServicioAdicional {
}

export class ServicioConfiguracion {
    constructor(props: IServicioConfiguracion) {
        Object.assign(this, props);
    }
}

export interface ServicioConfiguracion extends IServicioConfiguracion {
}
